// extracted by mini-css-extract-plugin
module.exports = {"StatsBanner":"styles_StatsBanner__88vxg","content":"styles_content__eRbaZ","stat":"styles_stat__GXIvN","value":"styles_value__quMzh","label":"styles_label__bkeN7"};